import React, { useState } from 'react';
import * as styles from './BuildEditorInstructions.module.css';
import { ResetAllWarningDialog } from 'concepts/Extraction/FormBuilder/ResetAllWarningDialog';
import { Button } from 'components/core/Button/Button';
import { IconList, Icon } from 'components/core/Icon';
import { Inline } from 'components/layout';

export type BuildEditorInstructionsProps = {
  onReset: () => void;
  showRevertButton: boolean;
  revertButtonOnClick: () => void;
  showReuseTemplateLink?: boolean;
  onReuseTemplate?: () => void;
};
export default function BuildEditorInstructions({
  onReset,
  showRevertButton,
  revertButtonOnClick,
  showReuseTemplateLink,
  onReuseTemplate,
}: BuildEditorInstructionsProps): JSX.Element {
  const [
    showResetAllWarningDialog,
    setShowResetAllWarningDialog,
  ] = useState<boolean>(false);

  return (
    <aside className={styles.BuildEditorInstructions}>
      <Inline spacing={3} alignX="left">
        {showReuseTemplateLink && (
          <Button
            type="primary"
            variant="solid"
            data-pendo-key="de2-reuse-template-open"
            onClick={onReuseTemplate}
          >
            <Icon icon={IconList.light.faFiles} />
            Re-use template
          </Button>
        )}
        <Button
          type="neutral"
          variant="outline"
          data-pendo-key="de2-delete-all-open"
          onClick={() => {
            setShowResetAllWarningDialog(true);
          }}
        >
          <Icon icon={IconList.light.faTrashCan} />
          Delete all
        </Button>
        <ResetAllWarningDialog
          isOpen={showResetAllWarningDialog}
          onDismiss={() => {
            setShowResetAllWarningDialog(false);
          }}
          onConfirm={() => {
            setShowResetAllWarningDialog(false);
            onReset();
          }}
        />
        {showRevertButton && (
          <Button
            type="neutral"
            variant="outline"
            data-pendo-key="de2-revert-to-published-open"
            onClick={revertButtonOnClick}
          >
            <Icon icon={IconList.light.faArrowLeftRotate} />
            Revert to published version
          </Button>
        )}
      </Inline>
    </aside>
  );
}
